import { BeconAccountTypes, BeconCommonTypes, BeconUserTypes } from "@becon-team/becon-fe-lib/my-types";
import { SkinInquiryDtoSchema } from "api/@skin/skin.dto";
import { z } from "zod";

export const TokenSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
});
export type Token = z.infer<typeof TokenSchema>;

export enum HairTypeEnum { // * 라이브러리 하위호환성 문제가 있을 수 있어서 임시로 하드코딩, 추후 라이브러리 업데이트 필요.
  STRAIGHT = "STRAIGHT",
  WAVY = "WAVY",
  CURLY = "CURLY",
  LOOSE_COIL = "LOOSE_COIL",
  COILY = "COILY",
  TIGHT_COIL = "TIGHT_COIL",
  UNKNOWN = "UNKNOWN",
}

export const AccountDtoSchema = z.object({
  account_id: z.string(),
  account_type: z.nativeEnum(BeconAccountTypes.AccountRoleEnum).nullable(),
  email: z.string(),
  phone_number: z.string().nullable(),
  region: z.nativeEnum(BeconCommonTypes.RegionEnum),
  role: z.nativeEnum(BeconAccountTypes.AccountRoleEnum).nullable(),
});

export type AccountDto = z.infer<typeof AccountDtoSchema>;

export const UserDtoSchema = z.object({
  user_id: z.string(),
  phone_number: z.string().nullable().optional(),
  region: z.nativeEnum(BeconCommonTypes.RegionEnum).nullable().optional(),
  nickname: z.string().nullable().optional(),
  gender: z.nativeEnum(BeconUserTypes.UserGenderEnum).nullable().optional(),
  age_group: z.nativeEnum(BeconUserTypes.AgeGroupEnum).nullable().optional(),
  hair_loss_type: z.nativeEnum(BeconUserTypes.HairlossTypeEnum).nullable().optional(),
  hair_loss_level: z.number().nullable().optional(),
  hairloss_family_history: z.nativeEnum(BeconUserTypes.HairlossFamilyHistoryEnum).nullable().optional(),
  scalp_issue: z
    .object({
      issue_1: z.nativeEnum(BeconUserTypes.ScalpIssueTypeEnum).nullable().optional(),
      issue_2: z.nativeEnum(BeconUserTypes.ScalpIssueTypeEnum).nullable().optional(),
      issue_3: z.nativeEnum(BeconUserTypes.ScalpIssueTypeEnum).nullable().optional(),
      level_1: z.number().nullable().optional(),
      level_2: z.number().nullable().optional(),
      level_3: z.number().nullable().optional(),
    })
    .optional()
    .nullable(),
  hair_damage_level: z.number().nullable().optional(),
  skin_color: z.nativeEnum(BeconUserTypes.SkinColorEnum).nullable().optional(),
  hair_color: z.nativeEnum(BeconUserTypes.HairColorEnum).nullable().optional(),
  hair_type: z.nativeEnum(HairTypeEnum).nullable().optional(),
  lifestyle: z
    .object({
      dyeing: z.nativeEnum(BeconUserTypes.NoneOrPeriodicalEnum).nullable().optional(),
      perm: z.nativeEnum(BeconUserTypes.NoneOrPeriodicalEnum).nullable().optional(),
    })
    .nullable()
    .optional(),
  privacy_term: z.boolean().nullable().optional(),
  sensitivity_term: z.boolean().nullable().optional(),
  service_term: z.boolean().nullable().optional(),
  marketing_agreement: z.boolean().nullable().optional(),
  skinInquiry: SkinInquiryDtoSchema.nullable(),
});
export type UserDto = z.infer<typeof UserDtoSchema>;

export const KakaoAccountDtoSchema = z.object({
  result: z.object({
    region: z.nativeEnum(BeconCommonTypes.RegionEnum),
    email: z.string(),
    access_token: z.string(),
    refresh_token: z.string(),
    account_id: z.string(),
  }),
});

export type KakaoAccountDto = z.infer<typeof KakaoAccountDtoSchema>;
